import React from 'react';
import {Col, Container, Row} from 'reactstrap';
import {FacebookShareButton, FacebookShareCount, TwitterShareButton, PinterestShareButton} from 'react-share';
import {faFacebookF, faTwitter, faPinterestP} from '@fortawesome/free-brands-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import './ShareButtons.scss';

export default function ShareButtons(props) {
  return (
    <>
      {props.floating ? (
        <div className="social-share social-share-floating">
          <ShareButtonsList {...props} />
        </div>
      ) : (
        <>
          {props.shareText ? (
            <div className="social-share-copy d-flex align-items-center justify-content-center">
              <div className="social-share-text mb-2 mb-sm-0 mr-sm-2">Share on social:</div>
              <div className="social-share d-flex align-items-center justify-content-center">
                <ShareButtonsList {...props} noDescription />
              </div>
            </div>
          ) : (
            <div className={classNames('social-share d-flex align-items-center', props.alignment)}>
              <ShareButtonsList {...props} noDescription />
            </div>
          )}
        </>
      )}
    </>
  );
}

ShareButtons.defaultProps = {
  alignment: 'justify-content-center justify-content-lg-end'
};

export function ShareButtonsList({
  pageTitle = 'The Need To GROW | Watch the full film – free!',
  pageDescription = 'Can we feed the world without destroying it?! Rosario Dawson’s award-winning film The Need To GROW shows the SOLUTIONS — and the real stories of the game-changing innovators behind them.',
  shareUrl = 'https://grow.foodrevolution.org/',
  shareImg = 'https://cdn.foodrevolution.org/tntg/social/tntg-open-graph-202106-1200x630.jpg',
  facebookDescription = 'Finally, a film focused on SOLUTIONS. Join in the online screening of Rosario Dawson’s award-winning film, The Need To GROW, right now — for free!',
  twitterDescription = 'We have fewer than 60 years of soil left on Earth! @RosarioDawson’s award-winning film @TheNeedToGROW delivers #SOLUTIONS & great stories. Watch it free! #SaveTheSoilSaveTheWorld',
  twitterHashtags = [null],
  pinterestDescription = 'Finally, a film focused on SOLUTIONS. Join in the online screening of Rosario Dawson’s award-winning film, The Need To GROW, right now — for free!',
  pinterestImg = 'https://cdn.foodrevolution.org/tntg/social/tntg-open-graph-202106-1000x1500.jpg',
  noDescription = false,
  ...props
}) {
  return (
    <>
      {noDescription ? null : (
        <div className="social-button">
          <div className="btn btn-social btn-social-share">Shares</div>
        </div>
      )}

      <FacebookShareButton className="social-button" url={shareUrl} quote={facebookDescription}>
        <div className="btn btn-social btn-social-facebook">
          <FontAwesomeIcon className="social-button-icon" icon={faFacebookF} />
          <span className="btn-social-description btn-social-description-facebook d-none d-md-inline">Facebook</span>
        </div>
      </FacebookShareButton>

      <TwitterShareButton
        className="social-button"
        url={shareUrl}
        via="afoodrevolution"
        hashtags={twitterHashtags}
        title={twitterDescription}
      >
        <div className="btn btn-social btn-social-twitter">
          <FontAwesomeIcon className="social-button-icon" icon={faTwitter} />
          <span className="btn-social-description btn-social-description-twitter d-none d-md-inline">Twitter</span>
        </div>
      </TwitterShareButton>

      <PinterestShareButton
        className="social-button"
        url={shareUrl}
        media={pinterestImg}
        description={pinterestDescription}
      >
        <div className="btn btn-social btn-social-pinterest">
          <FontAwesomeIcon className="social-button-icon" icon={faPinterestP} />
          <span className="btn-social-description btn-social-description-pinterest d-none d-md-inline">Pinterest</span>
        </div>
      </PinterestShareButton>
    </>
  );
}
